import randomInt from '../../utils/randomInt';

class Team {
  #name = null;
  #color = null;
  #codeMaster = null;
  #player = [];

  constructor(name, color) {
    if (name !== 'A' && name !== 'B') {
      throw 'Invalid team name';
    }

    this.#name = name;
    this.#color = color;
  }

  get name() {
    return this.#name;
  }

  get color() {
    return this.#color;
  }

  set color(color) {
    this.#color = color;
  }

  get player() {
    return this.#player;
  }

  addPlayer(player) {
    if (this.#player.filter((p) => p === player).length === 0) {
      this.#player.push(player);
    }

    player.team = this.name;
  }

  removePlayer(player) {
    const index = this.#player.findIndex((p) => {
      return p === player;
    });

    if (index < 0) {
      return;
    }

    this.#player.splice(index, 1);
    player.team = null;

    if (this.#codeMaster === player) {
      this.resetCodeMaster();
    }
  }

  defineCodeMaster(player) {
    this.#codeMaster = player;
  }

  resetCodeMaster() {
    this.#codeMaster = null;
  }

  hasCodeMaster() {
    return this.#codeMaster !== null;
  }

  isCodeMaster(player) {
    return this.#codeMaster === player;
  }

  static A(color = '#b34045') {
    return new Team('A', color);
  }

  static B(color = '#4091d7') {
    return new Team('B', color);
  }

  static random() {
    return randomInt(0, 1) ? Team.A() : Team.B();
  }

  toJson() {
    return {
      name: this.name,
      color: this.color,
      player: this.player.map((player) => {
        return {
          ...player.toJson(),
          isCodeMaster: this.isCodeMaster(player),
        };
      }),
    };
  }
}

export default Team;
